

























import Vue from 'vue';
import MStoreFilter from '@/components/shared/MStoreFilter.vue';
import { AppSettingsHelper } from '@/mixins/appSettingsHelper';
import { FilterDefaults } from '@/types/constants/TableConstants';
export default Vue.extend({
  name: 'HeaderFilters',
  mixins: [AppSettingsHelper],
  props: {
    searchQuery: {
      default: ''
    },
    showItemsPerPage: {
      type: Boolean,
      default: true
    },
    debounce: {
      type: Number
    }
  },
  data() {
    return {
      pageOptions: null,
      filterDefaultElementId: FilterDefaults.ElementId,
      filterContainerElementId: FilterDefaults.ContainerElementId
    };
  },
  computed: {
    localSearchQuery: {
      get(this: any) {
        return this.searchQuery;
      },
      set(this: any, value: any) {
        this.$emit('update:searchQuery', value);
      }
    },
    localPageOptions(this: any) {
      if (this.pageOptions) {
        return this.pageOptions;
      }
      const PAGE_OPTIONS = [];
      for (
        let i = this.paginationOptions?.minValue;
        i <= this.paginationOptions?.maxValue;
        i = i + this.paginationOptions?.incrementBy
      ) {
        PAGE_OPTIONS.push(i);
      }
      return PAGE_OPTIONS;
    }
  },
  components: { MStoreFilter }
});
